<template>
  <div class="chart" :style="{height:wapperHeight}">
    <ve-line
      :height="chartHeight"
      :data="chartData"
      color="#fff"
      :textStyle="textStyle"
      :settings="chartSettings"
      :extend="percentExtend"
    ></ve-line>
  </div>
</template>

<script>
import VeLine from 'v-charts/lib/line'

export default {
  components: { VeLine },
  name: 'lineChart',
  data () {
    let clientHeight = document.body.clientHeight
    function getValue (per) {
      return (per * clientHeight) / 100
    }
    this.chartSettings = {}
    return {
      wapperHeight: getValue(25) + 'px',
      chartHeight: getValue(30) + 'px',
      textStyle: {
        color: '#fff',
        fontWeight: 'bold'
      },
      percentExtend: {
        legend: {
          textStyle: {
            color: '#fff',
            fontWeight: 'bold'
          },
          itemGap: 30,
          top: 10
        }
      },
      chartData: {
        columns: ['日期', '微信', '支付宝'],
        rows: [
          { 日期: '11-1', 微信: 800, 支付宝: 500, 银行卡: 300, 现金: 0 },
          { 日期: '11-2', 微信: 800, 支付宝: 500, 银行卡: 11, 现金: 0 },
          { 日期: '11-3', 微信: 800, 支付宝: 1500, 银行卡: 300, 现金: 0 },
          { 日期: '11-4', 微信: 800, 支付宝: 500, 银行卡: 11, 现金: 0 },
          { 日期: '11-5', 微信: 800, 支付宝: 500, 银行卡: 11, 现金: 0 },
          { 日期: '11-6', 微信: 800, 支付宝: 500, 银行卡: 300, 现金: 0 }
        ]
      }
    }
  },
  methods: {
    onHandleToggleDate (item, index) {
      this.tooggleDateIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.chart {
  background-image: url("../../image/1414.png");
  background-size: 100% 100%;
  background-color: rgba(19, 54, 79, 0);
  color: #fff;
  width: 100%;
  touch-action: none;
}
</style>
